import { o_global } from "../../common/namespaces";
import { eventLoader, EventLoader } from "./Loader.js";

export { EventLoader, eventLoader };

o_global.EventLoader ||= EventLoader;
o_global.eventLoader ||= eventLoader();
